import Api32 from '@carbon/icons-react/es/api/32';
import React, { FC, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Route, Switch, useRouteMatch } from 'react-router';
import { Argon } from 'components/templates';
import { Home } from './home';
import { Sider, Group, Link } from './sider';
import { Styles } from './sub-routes/styles';
import { Title } from './title';

const options = [
  Group('Guides', '/guides', [
    Link('Getting started', '/getting-started'),
    Link('What is a component?', '/what-is-a-component'),
    Link('Atomic design', '/atomic-design'),
    Link('Creating custom components', '/creating-custom-components'),
    Link('Designing state', '/designing-state'),
    Link('Best practices', '/best-practices'),
  ]),
  Group('Styles', '/styles', [
    Link('Colors', '/colors'),
    Link('Typography', '/typography'),
    Link('Spacing', '/spacing'),
    Link('Shadows', '/shadows'),
  ]),
  Group('Atoms', '/atoms', [Link('Switcher', '/switcher')]),
  Group('Molecules', '/molecules', [Link('Action bar', '/action-bar')]),
  Group('Organisms', '/organisms', [
    Link('Rich text editor', '/rich-text-editor'),
  ]),
  Group('Templates', '/templates', [Link('Argon', '/argon')]),
  Group('Icons', '/icons', [Link('Icon set', '/icon-set')]),
  Group('Patterns', '/patterns', [
    Link('Disabled', '/disabled'),
    Link('Preview', '/preview'),
    Link('Feature', '/feature'),
    Link('State', '/state'),
    Link('Store', '/store'),
  ]),
  Group('Utilities', '/utilities', [
    Link('Theme', '/theme'),
    Link('Pixels', '/pixels'),
    Link('Z-Index', '/z-index'),
    Link('Unreachable', '/unreachable'),
  ]),
  Group('Playground', '/playground', [
    Link('Recipes', '/recipes'),
    Link('Showcase', '/showcase'),
  ]),
];

export const OzoneDesign: FC = () => {
  const [title] = useState('ozone');
  const { path } = useRouteMatch();

  return (
    <Argon
      actions={{}}
      title={<Title icon={<Api32 />}>{title}</Title>}
      sider={<Sider path={path} options={options} />}
      content={
        <Switch>
          <Route path={`${path}/styles`}>
            <Styles />
          </Route>
          <Route path="*">
            <Helmet>
              <title>Ozone.Design</title>
            </Helmet>
            <Home />
          </Route>
        </Switch>
      }
    />
  );
};
